export * from './baKameleonPicture.pipe';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/pipes/baKameleonPicture/index.ts